import React from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
    dataTestId: string;
    children: React.ReactNode;
    className?: string;
}

const CallTitleItem = ({ className, dataTestId, children }: Props) => (
    <div
        className={twMerge(
            'flex h-9 flex-col items-center justify-center text-xs/3 font-bold',
            className,
        )}
        data-test-id={dataTestId}
    >
        {children}
    </div>
);

export default React.memo(CallTitleItem);
